module.exports = __webpack_public_path__ + "img/saleo.7f851864.png";